import { useAtomValue, useSetAtom } from 'jotai'
import type { SelectedCardStatus } from './lib/checkDisabled'
import { scope } from './scope'

/**
 * カードの選択状態
 * context.card にセットする前の状態を保持し、UI の出し分けや context.card 更新前のバリデーションに利用する
 */
export const selectedCardStatus$ = scope.atom<SelectedCardStatus | undefined>(
  undefined,
  'selectedCardStatus$'
)

export function useSelectedCardStatus() {
  return useAtomValue(selectedCardStatus$)
}

export function useSetSelectedCardStatus() {
  return useSetAtom(selectedCardStatus$)
}

/** 削除済カード */
export const deletedCardIds$ = scope.atom<string[] | []>([], 'deletedCardIds$')

/** 予約入力画面で「予約完了」ボタンを押した時のトークン生成エラー */
export const tokenErrorOnReserve$ = scope.atom<string | undefined>(
  undefined,
  'tokenErrorOnReserve$'
)

export function useTokenErrorOnReserve() {
  return useAtomValue(tokenErrorOnReserve$)
}
